export const formatArgoWorkflowName = (path: string): string => path.substring(path.indexOf("/") + 38);
